import React, { useMemo } from 'react';
import { ItemIconContainer } from './styles';
import { ExamSearch } from '../../interfaces/exam';
import examIcon from '../../assets/images/icons/mevo/exam/exam.svg';

import { Text } from '../../components/UI-CHAKRA/Text';
import { Grid as ChakraGrid } from '../UI-CHAKRA/Grid';
import { GridItem } from '../UI-CHAKRA/GridItem';
import { Flex } from '../UI-CHAKRA/Flex';
import { Box } from '../UI-CHAKRA/Box';
import { EXAM_ORIGIN_BENEFIT } from '../../contants/examOriginBenefit';

interface ExamSearchItemProps {
  exam: ExamSearch;
}

function ExamSearchItem(props: ExamSearchItemProps) {
  const { exam } = props;

  const ExamBenefitChip = useMemo(() => {
    if (!exam.OrigemExame) return null;

    const benefit = EXAM_ORIGIN_BENEFIT[exam.OrigemExame];

    if (!benefit) return null;

    const hasBorder = benefit.borderColor !== 'transparent';

    return (
      <Flex
        mt={'5px'}
        borderRadius={'15px'}
        bg={benefit.backgroundColor}
        borderColor={benefit.borderColor}
        borderWidth={hasBorder ? '1px' : '0px'}
        borderStyle={hasBorder ? 'solid' : 'none'}
        p={'4px 10px'}
        maxW={'fit-content'}
        justifyContent={'center'}
        alignItems={'center'}
        display={{ base: 'none', md: 'flex' }}
      >
        <Box mb={'2px'} data-testid={benefit.testId}>
          <benefit.Icon />
        </Box>
        {benefit.label && (
          <Text fontSize={'12px'} fontWeight={700} color={benefit.textColor} ml={'5px'} lineHeight={0}>
            {benefit.label}
          </Text>
        )}
      </Flex>
    );
  }, [exam.OrigemExame]);

  return (
    <ChakraGrid
      templateColumns={'repeat(24, 1fr)'}
      h={'100%'}
      width={'100%'}
      whiteSpace={'initial'}
      wordBreak={'break-word'}
      alignItems={'center'}
      data-cy={`${exam.Nome}`}
    >
      <GridItem colSpan={{ base: 4, md: 2 }} display={'flex'} justifyContent={'center'}>
        <ItemIconContainer>
          <img src={examIcon} alt={'Ícone exame'} style={{ width: '80%', height: '80%' }} />
        </ItemIconContainer>
      </GridItem>

      <GridItem colSpan={{ base: 20, md: 22 }}>
        <Text
          color={'typography.darkest'}
          fontSize={{ base: 12, md: '14px' }}
          lineHeight={'16px'}
          whiteSpace={'normal'}
        >
          {exam.Nome}
        </Text>

        {ExamBenefitChip}
      </GridItem>
    </ChakraGrid>
  );
}

export default React.memo(ExamSearchItem);
